import { ApiService } from "../../../../services/api.service"

/**
 * @function - resetSubmitHandler - Function to send a password reset request
 * @param e - Event, used here to prevent the form default behavior
 * @param username - Username of the user requesting the password reset
 * @param setState - hook to set the Auth context state
 */
export const resetSubmitHandler = (e, username, setState) => {
  e.preventDefault()
  setState(prevState => ({ ...prevState, loading: true }))
  const payload = [{ username: username }]
  ApiService.post(process.env.RESET_PASSWORD_REQUEST, payload).then(
    (res: any) => {
      setState(prevState => ({
        ...prevState,
        message: {
          text: res.data,
          variant: res.status === 200 ? "info" : "danger",
        },
        loading: false,
      }))
    }
  )
}
